export const API_URL = import.meta.env?.VITE_APP_API_URL;
export const INTEGRATION_URL = import.meta.env?.VITE_APP_INTEGRATION_URL;
export const WS_URL = import.meta.env?.VITE_APP_WS_URL;
export const REDIRECT_URL = import.meta.env?.VITE_APP_REDIRECT_URL;
export const LANGUAGE = import.meta.env?.VITE_APP_LANGUAGE;
export const SHOW_DEBUG_ERRORS = import.meta.env?.VITE_APP_SHOW_DEBUG_ERRORS;
